export default "__VITE_ASSET__BxEGfOyb__"